import React, { useState, useEffect } from 'react';
import { NoBuilding } from '../../common';
import { Checkbox } from 'antd';

import DownloadSmall from '../assets/download-small.svg';

import './BillTable.css';
import '../../styles/billingPageStyles.css'

const convertInt2String = (num) => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const BillTable = ({ hasBuilding, roomInfo, setRoomInfo, setParentCheckedItems }) => {
    const [allChecked, setAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState([]);
    const [displayValues, setDisplayValues] = useState({});

    useEffect(() => {
        const initialDisplayValues = roomInfo.reduce((acc, room) => {
            acc[room.roomId] = room.lastPDFDownload;
            return acc;
        }, {});
        setDisplayValues(initialDisplayValues);
    }, [roomInfo]);

    useEffect (() => {
        setAllChecked(roomInfo.length > 0 && roomInfo.length === checkedItems.length);
    }, [checkedItems, roomInfo]);

    const handleAllChecked = () => {
        if (allChecked) {
            setCheckedItems([]);
            setParentCheckedItems([]);
        } else {
            const allRoomIds = roomInfo.map(room => room.roomId);
            setCheckedItems(allRoomIds);
            setParentCheckedItems(allRoomIds);
        }
    };

    const handleCheckboxChange = (roomId) => {
        setCheckedItems((prev) => {
            if (prev.includes(roomId)) {
                return prev.filter(id => id !== roomId);
            } else {
                return [...prev, roomId];
            }
        })
        setParentCheckedItems((prev) => {
            if (prev.includes(roomId)) {
                return prev.filter(id => id !== roomId);
            } else {
                return [...prev, roomId];
            }
        })
    };

    const handleClick = (id, e) => {
        const currentTime = updateTime();
        setRoomInfo(id, currentTime);

        setDisplayValues(prevValues => ({
            ...prevValues,
            [id]: currentTime,
        }));
    };

    const updateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
    
        const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      
        return formattedTime;
    };
    
    return (
        <table className="table">
            <thead>
                <tr>
                    <th className='whiteTable billTableColumn1'>
                        <div className="checkbox-wrapper">
                            <input type="checkbox" id="check" checked={allChecked} onChange={handleAllChecked} />
                            <label htmlFor="check"></label>
                        </div>
                    </th>
                    <th className='whiteTable billTableColumn2 tableHead'>호실명</th>
                    <th className='whiteTable billTableColumn3 tableHead'>임차사명</th>
                    <th className='grayTable billTableColumn4 tableHead'>전기세</th>
                    <th className='orangeTable billTableColumn5 tableHead'>수도세</th>
                    <th className='blueTable blueFont billTableColumn6'>청구금액</th>
                    <th className='whiteTable billTableColumn7 tableHead'>PDF 개별 다운로드</th>
                </tr>
            </thead>
            <tbody>
                {hasBuilding === false ? (
                    <tr>
                        <td colSpan="7">
                            <NoBuilding />
                        </td>
                    </tr>
                ) : (
                    roomInfo.length === 0 ? (
                        <tr>
                            <td colSpan="7">
                                <NoBuilding message="호실 상태가 입실인 호실을 추가해주세요!" />
                            </td>
                        </tr>
                    ) : (
                        roomInfo[0].roomId === -1 ? (
                            <tr>
                                <td colSpan="7">
                                    <NoBuilding message="호실 상태가 최신 정보가 아닙니다!<br>전기세와 수도세 계산 방문 후 다시 청구 탭을 방문해주세요." />
                                </td>
                            </tr>
                        ) : (
                            roomInfo.map((room, index) => {
                                return (
                                    <tr key={room.roomId}>
                                        <td className='whiteTable billTableColumn1'>
                                            <div className="checkbox-wrapper">
                                                <input type="checkbox" id={`${room.roomId}`} checked={checkedItems.includes(room.roomId)}  onChange={() => handleCheckboxChange(room.roomId)} />
                                                <label htmlFor={`${room.roomId}`}></label>
                                            </div>
                                        </td>
                                        <td className='whiteTable blueFont billTableColumn2 tableChild'>{room.roomName}</td>
                                        <td className='whiteTable billTableColumn3 tableChild'>{room.roomCustomerName}</td>
                                        <td className={`grayTable billTableColumn4 tablePrice tableChild boldFont`}>
                                            {room.totalElecPrice !== null ? (
                                                <div>
                                                    {convertInt2String(room.totalElecPrice)} 원
                                                </div>
                                            ) : (
                                                <div className='계산먼저'>
                                                    계산을 먼저 진행해주세요
                                                </div>
                                            )}
                                        </td>
                                        <td className={`orangeTable billTableColumn5 tablePrice tableChild boldFont`}>
                                            {room.totalWaterPrice !== null ? (
                                                <div>
                                                    {convertInt2String(room.totalWaterPrice)} 원
                                                </div>
                                            ) : (
                                                <div className='계산먼저'>
                                                    계산을 먼저 진행해주세요
                                                </div>
                                            )}
                                        </td>
                                        <td className={`blueTable blueFont billTableColumn6 tablePrice tableChild boldFont`}>
                                            {room.totalPrice !== null ? (
                                                <div>
                                                    {convertInt2String(room.totalPrice)} 원
                                                </div>
                                            ) : (
                                                <div className='계산먼저'>
                                                    계산을 먼저 진행해주세요
                                                </div>
                                            )}
                                        </td>
                                        <td className='whiteTable billTableColumn7 PDFDownload'>
                                            <div className='개별다운로드버튼감싸기'>
                                                <div className='마지막다운로드시간'>
                                                    최근 다운로드: {displayValues[room.roomId] !== null ? displayValues[room.roomId] : ""}
                                                </div>
                                                <button className='개별다운로드버튼' onClick={(e) => handleClick(room.roomId, e)}>
                                                    <img src={DownloadSmall} className='downloadSmall'/>
                                                    다운로드
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        )
                    )
                )}
            </tbody>
        </table>
    );
};

export default BillTable;
